import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "IPSC 2006",
  "description": "",
  "published": "2006-05-18T00:00:00.000Z",
  "redirect_from": ["/blog/ipsc-2006/swizec/414"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Some of you perhaps know of this wonderful thing called `}<a parentName="p" {...{
        "href": "http://ipsc2006.ksp.sk/index.php"
      }}>{`The IPSC`}</a>{`. Today makred my third attendance at this party of an event and it was the best one yet. For the first time I actually felt competent to solve something rather than jsut be there as an idea chest with silly ideas that might work... a brainstorming machine if you will. Anyway, we ranked 20th in the high school division and around 110th in the open division. It might not sound much, but it makes us the highest ranking team in the radious of something like 1000 kilometeres...`}</p>
    <p>{`In other news, I've started studying human gestures and have decided to create 1000 of these scrible-like drawrings. They are quite fun to make but provide practice for what is in my oppinion one of the most important aspects of drawing humans and human-like things. Fluency in motion and stature. Practice like this helps to make the body language of your work seem more real and so on. It's not about making pretty pictures though... at least the practice part isn't.`}</p>
    <p><a parentName="p" {...{
        "href": "http://img462.imageshack.us/my.php?image=kscan01161di.png"
      }}><img parentName="a" {...{
          "src": "https://img462.imageshack.us/img462/5443/kscan01161di.th.png",
          "alt": "Free Image Hosting at www.ImageShack.us"
        }}></img></a><a parentName="p" {...{
        "href": "http://img461.imageshack.us/my.php?image=kscan01170ad.png"
      }}><img parentName="a" {...{
          "src": "https://img461.imageshack.us/img461/6483/kscan01170ad.th.png",
          "alt": "Free Image Hosting at www.ImageShack.us"
        }}></img></a><a parentName="p" {...{
        "href": "http://img462.imageshack.us/my.php?image=kscan01181rb.png"
      }}><img parentName="a" {...{
          "src": "https://img462.imageshack.us/img462/1417/kscan01181rb.th.png",
          "alt": "Free Image Hosting at www.ImageShack.us"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      